<template>
  <div class="body">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="基本信息" name="first">
        <div>
          <table class="table" cellpadding="0" cellspacing="0">
            <tr>
              <td class="tableLabel">售后单号：</td>
              <td class="tableModel">{{maintainVo.billNo}}</td>
              <td class="tableLabel">出厂编号：</td>
              <td class="tableModel">{{maintainVo.factoryNo}}</td>
              <td class="tableLabel">客户名称：</td>
              <td class="tableModel">{{maintainVo.customerName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">现场名称：</td>
              <td class="tableModel">{{maintainVo.siteName}}</td>
              <td class="tableLabel">现场联系人：</td>
              <td class="tableModel">{{maintainVo.siteContacts}}</td>
              <td class="tableLabel">已过维保期：</td>
              <td class="tableModel">{{maintainVo.isMaintenancePeriod?"是":"否"}}</td>
            </tr>
            <tr>
              <td class="tableLabel">退回单号：</td>
              <td colspan="2" class="tableModel">{{maintainVo.backNo}}</td>
              <td class="tableLabel">退回日期：</td>
              <td colspan="2" class="tableModel">{{maintainVo.backTime}}</td>
            </tr>
            <tr>
              <td class="tableLabel">收货人：</td>
              <td colspan="2" class="tableModel">{{maintainVo.consignee}}</td>
              <td class="tableLabel">收货联系方式：</td>
              <td colspan="2" class="tableModel">{{maintainVo.consigneeContacts}}</td>
            </tr>
            <tr>
              <td class="tableLabel">收货地址：</td>
              <td colspan="5" class="tableModel">{{maintainVo.qualityDirecterName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">请求发货方式：</td>
              <td class="tableModel">{{maintainVo.deliveryMethod}}</td>
              <td class="tableLabel">请求发货日期：</td>
              <td class="tableModel">{{maintainVo.deliveryTime}}</td>
              <td class="tableLabel">运费是否到付：</td>
              <td class="tableModel">{{maintainVo.isFreightCollect?"是":"否"}}</td>
            </tr>
            <tr>
              <td class="tableLabel">备注：</td>
              <td colspan="5" class="tableModel">{{maintainVo.note}}</td>
            </tr>
          </table>
        </div>
        <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
          <div>
            <el-form
                ref="formUplosd"
                enctype="multipart/form-data"
                label-position="right"
                label-width="120px"
                size="mini">
              <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between">
                <div>
                  <div v-if="!maintainVo.accessories || !maintainVo.accessories.length">暂无附件</div>
                  <table width="100%">
                    <tr v-for="(item, index) in maintainVo.accessories" :key="index">
                      <td>附件{{index + 1}}</td>
                      <td style="cursor: pointer;padding:5px;color: #20a0ff" @click="openFile(item)">{{item.fileName}}</td>
                      <td style="padding:5px"><el-input v-model="item.note" size="mini"/></td>
                      <td style="padding:5px;color: #20a0ff;cursor: pointer;" @click="deleteFile(index)">删除</td>
                    </tr>
                  </table>
                </div>
                <div>
                  <el-upload
                      action=""
                      multiple
                      :http-request="submitUpload"
                      :show-file-list="false"
                      :disabled="uploadLoading"
                      style="display: inline-block; float: right; margin: 5px;">
                    <el-button type="primary" plain>
                      <i class="el-icon-upload el-icon--right"/>
                      附件上传
                    </el-button>
                  </el-upload>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="工作流详情" name="fourth">
        <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "MaintainPreview",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        activeName: "first",
        uploadLoading:false,
        maintainVo: {
          processExceptionMaterialVOS: [],
          accessories: [],
        },

      };
    },
    watch: {
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        console.log(this.params);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `maintains/${this.billId}`)
          .then(resp => {
            console.log(resp);
            this.$emit("loading-status", {"loading": false});
            this.maintainVo = resp;
          });
      },
      deleteFile(index) {
        this.maintainVo.accessories.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      doApprove() {
        //console.log(this.params.countersignVOS);
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          approveVar: this.params.approveVar,
          billParam: "",
        };
        console.log(this.params);
        // this.sentWeChat(0,"fanghl");
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            //退回到审批人时状态修改到未提交
            if (this.params.actionType ===2 && this.params.untreadedFlowId === "0;submitter") {
              this.updateStatus();
            }
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/Maintain",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.maintainVo.accessories.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      updateStatus() {
        this.$http
          .get("basic", `maintains/updateStatus/${this.maintainVo.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      sentMessage() {
        let name = "";
        let userId = 0;
        switch (this.params.nodeId) {
          case "DealDepartment":
            console.log("sentMessagesentMessagesentMessagesentMessage");
            console.log(this.params.applicationVarVOS);
            if (this.params.applicationVarVOS.length>0) {
              if (this.params.applicationVarVOS[0].varValue === "特批" && this.params.applicationVarVOS[1].varValue === "true") {
                this.sentWeChat(0,"fanghl");
                // if (this.params.applicationVarVOS[2].varValue === "true") {
                //   // this.sentWeChat(0,"wangtj");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[3].varValue === "true") {
                //   // this.sentWeChat(0,"liuyf");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[4].varValue === "true") {
                //   // this.sentWeChat(0,"yuyong");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[5].varValue === "true") {
                //   // this.sentWeChat(0,"liuym");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[6].varValue === "true") {
                //   // this.sentWeChat(0,"cailg");
                //   this.sentWeChat(0,"fanghl");
                // }
              }

            }
            break;
          case "CountersignComments_ht":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_ds":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_bs":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_cg":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_clg":
            console.log(this.params.applicationVarVOS);
            break;
          case "Managerriskassessment":
            break;
        }
      },
      sentWeChat(userId,name) {
        let params = {
          userId:userId,
          name:name,
          pkid:this.maintainVo.pkid,
          formId:26,
        };
        console.log(params);
        this.$http
          .get("basic", "inspectionInComings/sentWeChat",params)
          .then(() => {
          });
      },
    },
  };
</script>
<style lang="scss">
  .body {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }
</style>
